import { render, staticRenderFns } from "./bSectionView.vue?vue&type=template&id=4184037f&scoped=true"
import script from "./bSectionView.vue?vue&type=script&lang=js"
export * from "./bSectionView.vue?vue&type=script&lang=js"
import style0 from "./bSectionView.vue?vue&type=style&index=0&id=4184037f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4184037f",
  null
  
)

export default component.exports